export default "__VITE_ASSET__BwXE_CWK__"